import React from 'react'

export default function YajnaHall() {
    return (
        <div>YajnaHall</div>
    )
}
